(function () {
    'use strict';

    // @ngInject
    Services.pnotify = function momentJS($window) {
        return $window.PNotify;
    };

}());
